/**
 * Records each rendered route so /contact can say where a report came from.
 * Registered in `config.settings.appExtras` with `match: ''` — it renders
 * nothing, on the server or the client, and only writes to sessionStorage in
 * an effect, so it cannot affect SSR output or the shared edge HTML cache.
 * See routeTrail.js for why the referrer header cannot do this job.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordRoute } from './routeTrail';

const RouteTrail = () => {
  const location = useLocation();
  const pathname = location && location.pathname;
  useEffect(() => {
    recordRoute(pathname);
  }, [pathname]);
  return null;
};

export default RouteTrail;
